"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chartOptions = {
    plugins: {
        legend: {
            display: false,
        },
    },
    scales: {
        x: {
            grid: {
                display: false,
            },
            ticks: {
                font: {
                    family: 'Noto Sans Armenian',
                    size: '11',
                    style: 'normal',
                    lineHeight: 1.2,
                },
                color: '#43425D',
            },
        },
        y: {
            beginAtZero: true,
            ticks: {
                font: {
                    family: 'Noto Sans Armenian',
                    size: '11',
                    style: 'normal',
                    lineHeight: 1.2,
                },
                color: '#43425D',
                suggestedMin: 0,
                suggestedMax: 200,
                stepSize: 10,
            },
            grid: {
                color: '#EAF0F4',
                borderWidth: 0,
            },
            min: 0,
            max: 50,
        },
    },
};
exports.default = chartOptions;
